<template>
  <van-popup
    :value="show"
    @close="close"
    @click-overlay="close"
    @click-close-icon="close"
    position="center"
    class="popup"
  >
    <div class="popup-wrap">
      <van-icon name="cross" color="#CCCCCC" class="icon" @click="close" />
      <div class="title">确定关闭自动续费吗？</div>
      <div class="content">
        关闭后，权益到期将自动失效，不再享受会员特权，也无法领取相关权益。
      </div>
      <div class="btn" @click="handleViewBenefit">查看权益</div>
      <div class="text-btn" @click="handleCloseRenewal">关闭自动续费</div>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import { defineComponent } from "@vue/composition-api";

import { useRouter, useStore, useRoute } from "@/components/use/base";

import { cancelMonthlySubscription } from "@/apis/jiayin";

const vm = Vue.prototype;

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const route = useRoute();

    const close = () => {
      store.commit("setShowCancelRenewalModal", false);
    };

    const handleViewBenefit = () => {
      router.replace(`/index?orderId=${store.state?.orderId}`);
    };

    const handleCloseRenewal = async () => {
      await cancelMonthlySubscription({
        orderId: store.state.orderId,
      });
      vm.$toast({
        message: "关闭自动续费已成功，感谢您的使用～",
        onClose: () => {
          router.replace({
            path: "/index",
            query: {
              ...route.query,
              orderId: store.state.orderId,
            },
          });
        },
      });
      await store.dispatch("fetchUserInfo");
      close();
    };

    return {
      close,
      handleCloseRenewal,
      handleViewBenefit,
    };
  },
});
</script>

<style scoped lang="less">
.popup {
  width: 295px;
  height: 220px;
  background: #ffffff;
  border-radius: 8px;
}

.popup-wrap {
  position: relative;
  padding-top: 28px;
  padding-left: 16px;
  padding-right: 16px;
  box-sizing: border-box;

  .icon {
    font-size: 16px;
    font-weight: 600;
    position: absolute;
    right: 12px;
    top: 12px;
  }
}

.title {
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  text-align: center;
}

.content {
  font-weight: 400;
  font-size: 12px;
  color: #444444;
  line-height: 20px;
  margin-top: 19px;
}

.btn {
  margin-top: 24px;
  background: linear-gradient(115deg, #4082e7 0%, #3254f2 100%);
  height: 40px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 17px;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}

.text-btn {
  margin-top: 12px;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 17px;
  text-align: center;
}
</style>